export class NavigationClickContext {
  constructor(readonly defaultDelay: number = 100) {}

  click<A>(_action: () => A): A {
    throw new Error("TODO");
  }

  close() {
    if (this.closed) {
      throw new Error("Tried to close a NavigationClickContext that is already closed");
    }
    this.closed = true;
  }

  private closed = false;
}
